import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ColectiveAgreementListComponent } from './colective-agreement-list/colective-agreement-list.component';
import { ColectiveAgreementDetailComponent } from './colective-agreement-detail/colective-agreement-detail.component';

const routes: Routes = [
    {
        path: 'colective-agreements',
        children: [
            { path: '', component: ColectiveAgreementListComponent }
        ]
    },
    {
        path: 'colective-agreements/:id',
        children: [
            { path: '', component: ColectiveAgreementDetailComponent }
        ]
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ColectiveAgreementRoutingModule { }
